export default __webpack_public_path__ + "static/media/check.20fb7110.gif";